export default "__VITE_ASSET__f0b33921__"